'use client'

import Image from 'next/image'

export default function ScrollToTopButton() {
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="relative inline-flex items-center h-14 sm:h-16 w-[50px] sm:w-[60px] ml-1 cursor-pointer hover:opacity-80 transition-opacity"
      aria-label="Scroll to top"
    >
      <Image
        src="/images/submark.png"
        alt="dday Logo"
        fill
        sizes="60px"
        className="object-contain"
      />
    </button>
  )
}
